import ProgramStatusReason from "./ProgramStatusReason";
import * as reasonSupport from "./ProgramStatusReason.support";
import StatusOverrideSelector from "./StatusOverrideSelector";
import { Grid } from "@mui/material";
import Component from "components/Component";
import StatusBadgeV2 from "components/common/StatusBadgeV2";
import * as config from "config";
import { useDispatch, useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as programActions from "store/actions/input/program/programActions";
import * as programSelectors from "store/selectors/input/program/programSelectors";

// The program's status and the reason for it, together at the top of the
// Details page: the user overrides the status, then says why. The reason is
// recorded against the status it explains (see resolveStatusReason).
const ProgramStatus = () => {
  const dispatch = useDispatch();
  const program = useSelector(programSelectors.selectProgram);
  const resolvedProgram = useSelector(programSelectors.selectResolvedProgram);
  const status = resolvedProgram?.status ?? null;
  const statusReason = resolvedProgram?.statusReason ?? null;
  const { data: statusLabels } = staticDataService.useConfigQuery(
    "layer_status_labels_v2"
  );
  const isReasonVisible = reasonSupport.isReasonShown(
    statusLabels,
    status,
    statusReason
  );

  const updateProgram = (values) =>
    dispatch(programActions.updateProgram(values));

  return (
    <Component
      title={"Status"}
      options={
        status != null ? (
          <StatusBadgeV2 status={status} variant={"chip"} />
        ) : null
      }
    >
      <Grid container spacing={config.GRID_SPACING}>
        <Grid item xs={12} lg={isReasonVisible ? 6 : 12}>
          <StatusOverrideSelector
            program={program}
            updateProgram={updateProgram}
            label={"Override"}
          />
        </Grid>
        {isReasonVisible && (
          <Grid item xs={12} lg={6}>
            <ProgramStatusReason
              status={status}
              value={statusReason}
              onChange={(statusReason) =>
                updateProgram({
                  statusReason,
                  statusReasonStatus: statusReason == null ? null : status,
                })
              }
            />
          </Grid>
        )}
      </Grid>
    </Component>
  );
};

export default ProgramStatus;
